export default [
  'dashboard',
  'web'
]